import { memo } from 'react';
import { useParams } from 'react-router-dom';
import PromoDetails from '../components/PromoDetails/PromoDetails';

function PromoDetailsPage() {
  const { id } = useParams();

  return <PromoDetails id={id ?? ''} />;
}

export default memo(PromoDetailsPage);
